import { UpscSeoPageConfig } from './upscSeoTypes';

export const UPSC_SITE_ORIGIN = (
  process.env.DOMAIN || 'https://unacademy.com'
).replace(/\/$/, '');

export const resolveUpscStructuredData = (structuredData: unknown) => {
  if (!structuredData) {
    return undefined;
  }

  const todayIso = new Date().toISOString();

  const replaceDynamicValues = (value: unknown): unknown => {
    if (typeof value === 'string') {
      return value.includes('DYNAMIC') && value.includes('TODAY')
        ? todayIso
        : value;
    }

    if (Array.isArray(value)) {
      return value.map(replaceDynamicValues);
    }

    if (value && typeof value === 'object') {
      return Object.fromEntries(
        Object.entries(value).map(([key, nestedValue]) => [
          key,
          replaceDynamicValues(nestedValue)
        ])
      );
    }

    return value;
  };

  return replaceDynamicValues(structuredData);
};

export const getUpscCanonicalUrl = (path: string) => {
  const normalizedPath = path.split('?')[0].split('#')[0] || '/';

  if (normalizedPath === '/') {
    return `${UPSC_SITE_ORIGIN}/`;
  }

  return `${UPSC_SITE_ORIGIN}${
    normalizedPath.startsWith('/') ? '' : '/'
  }${normalizedPath}`;
};

export const resolveUpscArticlePageSeo = (
  pageSeo?: UpscSeoPageConfig | null,
  article?: {
    metaTitle?: string;
    metaDescription?: string;
  } | null
): UpscSeoPageConfig | null => {
  if (!pageSeo) {
    return null;
  }

  return {
    ...pageSeo,
    metaTitle: (article?.metaTitle || pageSeo.metaTitle || '').trim(),
    metaDescription: (
      article?.metaDescription ||
      pageSeo.metaDescription ||
      ''
    ).trim()
  };
};
